import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Redo = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Redo" {...props}>
    <path d="M16.1026 4.03727C16.4688 3.67105 17.0487 3.64828 17.4415 3.96891L17.5176 4.03727L21.668 8.18766C22.1092 8.62896 22.1093 9.34503 21.668 9.78629L17.5176 13.9367L17.4415 14.005C17.0487 14.3256 16.4688 14.3028 16.1026 13.9367C15.7124 13.5462 15.7124 12.9131 16.1026 12.5226L18.626 10.0002H7.96002C7.14192 10.0002 6.34409 10.2538 5.67584 10.7257C3.44213 12.3036 3.4421 15.6167 5.67584 17.1945C6.34406 17.6664 7.14197 17.9201 7.96002 17.9201H9.95806L10.0606 17.925C10.5649 17.9761 10.9581 18.4023 10.9581 18.9201C10.958 19.4378 10.5649 19.8641 10.0606 19.9152L9.95806 19.9201H7.96002C6.72865 19.9201 5.52734 19.5387 4.52154 18.8283C1.15963 16.4536 1.15967 11.4667 4.52154 9.09195C5.52736 8.38152 6.7286 8.00016 7.96002 8.00016H18.6524L16.1026 5.45133C15.7124 5.06088 15.7124 4.42774 16.1026 4.03727Z" fill="#000" />
  </StyledIcon>
));

Redo.displayName = 'Redo';

export { Redo };
